import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { offerConstants, parsePayloadObj, removeObjEmptyValues, removeObjProperties, setCreateOrUpdateItem } from '..';

export function useCreateOrUpdateOffer() {
  const qc = useQueryClient();
  const dispatch = useDispatch();
  const payload = useAppSelector(({ offerReducer: { createOrUpdate } }) => createOrUpdate);
  const realtors = payload?.realtors?.filter(value => value !== 0);

  const [query] = useQueryParams({
    search: StringParam,
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10)
  });

  return useMutation(
    async () => {
      const { data } = await $api.post(
        '/v1/offer',
        removeObjEmptyValues(
          parsePayloadObj(
            removeObjProperties({ ...payload, realtors }, 'isDirtyHouseOrBuilding', 'visible')
          )
        )
      );

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries([offerConstants.queryKeys.OFFER, query]);

        dispatch(
          setCreateOrUpdateItem({
            key: 'visible',
            value: false
          })
        );

        showMessage(data?.message, true);
      }
    }
  );
}
